import { z } from "zod";

/**
 * Webhook status enum
 */
export const WebhookStatusSchema = z.enum(["REGISTERED", "PENDING", "FAILED", "NOT_REQUIRED"]);
export type WebhookStatus = z.infer<typeof WebhookStatusSchema>;
